<template>
  <transition name="fade">
    <div class="toast fade show" :data-autohide="autohide">
      <div class="toast-header">
        <slot name="title"></slot>
      </div>
      <div class="toast-body">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BootstrapToast',
  props: {
    autohide: { type: Boolean, default: true }
  }
}
</script>

<style scoped>

</style>
